import type { identidade as pt } from '../pt-BR/identidade';
import type { Traducao } from '../Traducao';

export const identidade = {
  titulo: 'Tu registro',
  vinculado: 'Registro encontrado: {{nome}}',
  falha: {
    titulo: 'No encontramos tu registro',
    descricao:
      'No pudimos asociar tu inicio de sesión a un registro de profesional. Contacta al equipo responsable de la campaña.',
  },
  ultimoConhecido:
    'Mostrando la última verificación; el registro no está disponible temporalmente.',
} as const satisfies Traducao<typeof pt>;
